import React, { useEffect, useState } from 'react'
import strings from 'utils/strings'
import { Button } from 'components/patterns'
import SearchInput from 'components/patterns/Inputs/SearchInputV2'
import * as yup from 'yup'
import { event as trackEvent } from 'utils/analytics'
import { Box, InputBox } from './ContextualHelpvehicleSearch.style'

const ContextualHelpVehicleSearch = () => {
  const [value, setValue] = useState('')
  const [disabled, setDisabled] = useState(true)

  const regexAlphaNumericSpaces = new RegExp(/^[\w\-\s]+$/)

  useEffect(() => {
    if (value.length) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [value])

  const createQueryString = () => {
    const serials = value.split(' ')
    const queryString = serials.reduce((acc, curr, index) => {
      if (index < serials.length - 1) return `${acc}${curr}+`

      return `${acc}${curr}`
    }, '')

    return queryString
  }

  const googleAnalyticsEvent = () => {
    trackEvent({
      category: 'Feature',
      action: 'Search Vehicle from Feature',
      label: 'Contextual Help',
    })
  }

  const handleOnSearch = () => {
    googleAnalyticsEvent()

    const queryString = createQueryString()
    const gaSearchTracking = '&sc=Vehicle+Search'
    const url = `/chec/vehicles?q=${queryString}${gaSearchTracking}`

    const win = window.open(url, '_blank')
    win.focus()
  }

  const handleOnClick = () => {
    handleOnSearch()
  }

  const handleOnChange = (e) => {
    const val = e.target.value
    if (val.length && regexAlphaNumericSpaces.test(val)) {
      setValue(val)
    } else {
      setValue('')
    }
  }

  const handleOnClear = () => {
    setValue('')
  }

  return (
    <Box>
      <InputBox>
        <SearchInput
          placeholder={strings.enter_a_serial_number_dot_dot_dot}
          value={value}
          name="feature-search-vehicles"
          rules={yup.string()}
          onChange={handleOnChange}
          onSearch={handleOnSearch}
          onClear={handleOnClear}
          width="214"
        />
      </InputBox>
      <Button
        type="secondary"
        onClick={handleOnClick}
        disabled={disabled}
        text={strings.lets_go}
      />
    </Box>
  )
}

export default ContextualHelpVehicleSearch
